window.monitoringRequestHowFormatter = function(value, row) {
    switch (value) {
        case "OK":
            return '<span class="badge badge-monitoring-request-how-ok">OK</span>';
        case "FAILED":
            return '<span class="badge badge-monitoring-request-how-failed">FAILED</span>';
        case "WARNING":
            return '<span class="badge badge-monitoring-request-how-warning">WARNING</span>';
        case "IGNORED":
            return '<span class="badge badge-monitoring-request-how-ignored">IGNORED</span>';
        case "UNKNOWN":
            return '<span class="badge badge-monitoring-request-how-unknown">UNKNOWN</span>';
        case "INFO":
            return '<span class="badge badge-monitoring-request-how-info">INFO</span>';
        default:
            return value;
    }
};
